import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import pushToDashamail from "./dashamail";
export var subscribeEmailURLDefault = '/shop/basket/subscribe/';
export var subscribeMailingList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var email, url, onSuccess, onError, formData, requestData, response, _data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          email = _ref.email, url = _ref.url, onSuccess = _ref.onSuccess, onError = _ref.onError;
          formData = new FormData();
          requestData = {
            subscriber: {
              email: email,
              data_source: window.location.href,
              subscribe: true
            }
          };
          formData.append('json', JSON.stringify(requestData));
          _context.prev = 4;
          _context.next = 7;
          return fetch(url || subscribeEmailURLDefault, {
            method: 'POST',
            body: formData
          });
        case 7:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 18;
            break;
          }
          _context.next = 11;
          return response.json();
        case 11:
          _data = _context.sent;
          if (!_data.Data.Success) {
            _context.next = 16;
            break;
          }
          if (onSuccess) {
            onSuccess(_data);
          }
          pushToDashamail({
            email: email
          });
          return _context.abrupt("return", true);
        case 16:
          if (onError) {
            onError(_data.Data.Error.Message);
          }
          return _context.abrupt("return", false);
        case 18:
          if (onError) {
            onError();
          }
          _context.next = 25;
          break;
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](4);
          // eslint-disable-next-line no-console
          console.error(_context.t0);
          if (onError) {
            onError();
          }
        case 25:
          return _context.abrupt("return", false);
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 21]]);
  }));
  return function subscribeMailingList(_x) {
    return _ref2.apply(this, arguments);
  };
}();